import {
  Row,
  Col,
  Card,
  Table,
  Button,
  Modal,
  Form,
  Input,
  Tag,
  Collapse,
  Tabs,
  Checkbox,
} from "antd";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import React, { useState, useContext, useEffect, useRef } from "react";
import useRequest from "../hooks/useRequest";
import { ToTopOutlined, ExclamationCircleOutlined } from "@ant-design/icons";
import { ShowToast, Severty } from "../helper/toast";
import Main from "../components/layout/Main";
import useDebounce from "../hooks/useDebounce";
import { useNavigate, useParams } from "react-router";
import TabPane from "antd/lib/tabs/TabPane";
import { ExportOutlined } from "@ant-design/icons";
import * as XLSX from "xlsx";
import moment from "moment";
import EditRecordModal from "../components/EditRecordModal";
const Search = Input.Search;
const { Panel } = Collapse;
const DownTownData = () => {
  const { confirm } = Modal;
  const { request } = useRequest();
  const tableRef = useRef(null);
  const [searchText, setSearchText] = useState("");
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });
  const [list, setList] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isRestoreReady, setIsRestoreReady] = useState(false);
  const [listExport, setListExport] = useState([]);
  const debouncedSearchText = useDebounce(searchText, 300);
  const params = useParams();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [selectAllChecked, setSelectAllChecked] = useState(false);
  const [deselectAllChecked, setDeselectAllChecked] = useState(false);
  const [selectAllCheckedNew, setSelectAllCheckedNew] = useState(false);
  const [deselectAllCheckedNew, setDeselectAllCheckedNew] = useState(false);
  const [activeTab, setActiveTab] = useState(params.type);
  const [visibleFields, setVisibleFields] = useState({
    property_number: false,
    name: true,
    email: true,
    phone: false,
    mobile_number: true,
    mobile_number_code: true,
    country_code: true,
    plot_number: true,
    flat_number: true,
    actual_area: false,
    municioality_number: false,
    parking_number: false,
    common_area: false,
    floor: false,
    secondary_mobile: false,
    note: false,
    nationality: false,
    country: false,
    building_name: false,
    room_description: false,
    type: false,
    vila_number: false,
    location: false,
    project_name: false,
    file_name: false,
  });
  const [isCollapsed, setIsCollapsed] = useState(true);

  const toggleCollapse = () => {
    setIsCollapsed(!isCollapsed);
  };

  const [isCollapsed1, setIsCollapsed1] = useState(true);
  const toggleCollapse1 = () => {
    setIsCollapsed1(!isCollapsed1);
  };
  const [visibleFieldsNew, setVisibleFieldsNew] = useState({
    property_number: true,
    name: true,
    email: true,
    phone: true,
    mobile_number: true,
    mobile_number_code: true,
    country_code: true,
    plot_number: true,
    flat_number: true,
    actual_area: true,
    municioality_number: true,
    parking_number: true,
    common_area: true,
    floor: true,
    secondary_mobile: true,
    note: true,
    nationality: true,
    country: true,
    building_name: true,
    room_description: true,
    type: true,
    vila_number: true,
    location: true,
    project_name: true,
    file_name: true,
  });
  const [searchParams, setSearchParams] = useState({
    property_number: "",
    name: "",
    floor: "",
    email: "",
    mobile: "",
  });
  const debouncedSearchParams = useDebounce(visibleFieldsNew, 300);
  const handleExport = () => {
    const data =
      listExport && listExport.length > 0
        ? listExport.map((row) => {
          const exportRow = {};
          if (visibleFields.file_name) {
            exportRow["File Name"] = row.downtownData
              ? row.downtownData.file_name
              : "-" || "-";
          }
          if (visibleFields.project_name) {
            exportRow["Project"] = row.downtownData
              ? row.downtownData.projectData
                ? row.downtownData.projectData.name
                : "-"
              : "-" || "-";
          }
          if (visibleFields.location) {
            exportRow["Location"] = row.downtownData
              ? row.downtownData.locationData
                ? row.downtownData.locationData.name
                : "-"
              : "-" || "-";
          }

          if (visibleFields.name) {
            exportRow["Name"] = row.name || "-";
          }
          if (visibleFields.email) {
            exportRow["Email"] = row?.email || "-";
          }
          if (visibleFields.phone) {
            exportRow["Phone"] = row?.phone || "-";
          }
          if (visibleFields.country_code) {
            exportRow["Country Code"] = row?.country_code || "-";
          }
          if (visibleFields.mobile_number) {
            exportRow["Mobile Number"] = row?.mobile_number
              ? row?.mobile_number
              : row?.mobile_number || "-";
          }
          if (visibleFields.mobile_number_code) {
            // exportRow["Full Mobile Number"] = row?.country_code
            //   ? row?.country_code + " " + row?.mobile_number
            //   : row?.mobile_number || "-";
            exportRow["Full Mobile Number"] =
              row?.country_code && row?.mobile_number
                ? row?.country_code +
                (row?.mobile_number.startsWith("0")
                  ? row?.mobile_number.slice(1)
                  : row?.mobile_number)
                : row?.mobile_number && row?.mobile_number.startsWith("0")
                  ? row?.mobile_number
                  : row?.mobile_number || "--";
          }
          if (visibleFields.flat_number) {
            exportRow["Flat Number"] = row.flat_number || "-";
          }
          if (visibleFields.plot_number) {
            exportRow["Plot Number"] = row.plot_number || "-";
          }
          if (visibleFields.vila_number) {
            exportRow["Vila Number"] = row.vila_number || "-";
          }
          if (visibleFields.building_name) {
            exportRow["Building Name"] = row.building_name || "-";
          }

          if (visibleFields.room_description) {
            exportRow["Rooms"] = row.room_description || "-";
          }
          if (visibleFields.type) {
            exportRow["Property Type"] = row.downtownData
              ? row.downtownData.type
              : "-" || "-";
          }
          if (visibleFields.floor) {
            exportRow["Floor"] = row.floor || "-";
          }
          if (visibleFields.actual_area) {
            exportRow["Actual Area"] = row.actual_area || "-";
          }

          if (visibleFields.common_area) {
            exportRow["Common Area"] = row.common_area || "-";
          }
          if (visibleFields.parking_number) {
            exportRow["Parking Number"] = row.parking_number || "-";
          }
          if (visibleFields.country) {
            exportRow["Country"] = row.country || "-";
          }
          if (visibleFields.nationality) {
            exportRow["Nationality"] = row.nationality || "-";
          }
          if (visibleFields.municioality_number) {
            exportRow["Municipality Number"] = row.municioality_number || "-";
          }
          if (visibleFields.nationality) {
            exportRow["Nationality"] = row.nationality || "-";
          }

          if (visibleFields.secondary_mobile) {
            exportRow["Secondary Mobile"] = row.secondary_mobile || "-";
          }

          if (visibleFields.property_number) {
            exportRow["Property Number"] = row.property_number || "-";
          }
          if (visibleFields.note) {
            exportRow["Comment"] = row.note || "-";
          }
          if (visibleFields.land_number_plot_no) {
            exportRow["Land Number"] = row.note || "-";
          }

          if (visibleFields.building_name_new) {
            exportRow["Building Name"] = row.note || "-";
          }
          if (visibleFields.gender) {
            exportRow["gender"] = row.note || "-";
          }
          if (visibleFields.company_name) {
            exportRow["company_name"] = row.note || "-";
          }

          if (selectAllChecked) {
            exportRow["Area"] = row.area || "-";
            exportRow["Total Area"] = row.total_area || "-";
            exportRow["ADDRESS"] = row.address || "-";
            exportRow["Balcony Area"] = row.balcony_area || "-";

            exportRow["Phase"] = row.project || "-";
          }
          return exportRow;
        })
        : [];

    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.json_to_sheet(data);
    XLSX.utils.book_append_sheet(workbook, worksheet, "Refine Data");

    // Format file name with date and time
    XLSX.writeFile(
      workbook,
      `${moment().format("YYYYMMDD_HHmmss")}-Refine.xlsx`
    );
  };
  const [editingRecord, setEditingRecord] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const handleEdit = (record) => {
    setEditingRecord(record);
    setIsModalVisible(true);
  };

  const ViewDataChange = (id, type) => {
    navigate(`/view-data/${id}/${type}`);
  };

  // useEffect(() => {
  //   console.log(editingRecord, "editingRecord")
  //   if (editingRecord)
  //     form.setFieldValue({ ...editingRecord })
  // }, [editingRecord])

  const RowDatacolumns = [
    {
      title: "P-Number",
      dataIndex: "property_number",
      key: "property_number",
      render: (_, { property_number }) => {
        return <div>{property_number ? property_number : "--"}</div>;
        // { is_active ? "Active" : "Inactive" }
      },
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (_, { name }) => {
        return <div>{name ? name : "--"}</div>;
        // { is_active ? "Active" : "Inactive" }
      },
    },
    {
      title: "Company Name",
      dataIndex: "company_name",
      key: "company_name",
      render: (_, { company_name }) => {
        return <div>{company_name ? company_name : "--"}</div>;
        // { is_active ? "Active" : "Inactive" }
      },
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      render: (_, { email }) => {
        return <div>{email ? email : "--"}</div>;
        // { is_active ? "Active" : "Inactive" }
      },
    },
    {
      title: "Phone",
      dataIndex: "phone",
      key: "phone",
      render: (_, { phone }) => {
        return <div>{phone ? phone : "--"}</div>;
        // { is_active ? "Active" : "Inactive" }
      },
    },
    {
      title: "Country Code",
      dataIndex: "country_code",
      key: "country_code",
      render: (_, { country_code }) => {
        return <div>{country_code ? country_code : "--"}</div>;
        // { is_active ? "Active" : "Inactive" }
      },
    },
    {
      title: "Mobile Number",
      dataIndex: "mobile_number",
      key: "mobile_number",
      render: (_, { mobile_number }) => {
        return <div>{mobile_number ? mobile_number : "--"}</div>;
        // { is_active ? "Active" : "Inactive" }
      },
    },
    {
      title: "Full Mobile Number",
      dataIndex: "mobile_number_code",
      key: "mobile_number_code",
      render: (_, { country_code, mobile_number }) => {
        return (
          <div>
            {country_code && mobile_number
              ? country_code +
              (mobile_number.startsWith("0")
                ? mobile_number.slice(1)
                : mobile_number)
              : mobile_number && mobile_number.startsWith("0")
                ? mobile_number.slice(1)
                : mobile_number}
          </div>
        );
        // { is_active ? "Active" : "Inactive" }
      },
    },
    {
      title: "Building Name",
      dataIndex: "building_name_new",
      key: "building_name_new",
      render: (_, { building_name_new }) => {
        return <div>{building_name_new ? building_name_new : "--"}</div>;
        // { is_active ? "Active" : "Inactive" }
      },
    },
    {
      title: "Plot Number",
      dataIndex: "plot_number",
      key: "plot_number",
      render: (_, { plot_number }) => {
        return <div>{plot_number ? plot_number : "--"}</div>;
        // { is_active ? "Active" : "Inactive" }
      },
    },
    {
      title: "Land Number",
      dataIndex: "land_number_plot_no",
      key: "land_number_plot_no",
      render: (_, { land_number_plot_no }) => {
        return <div>{land_number_plot_no ? land_number_plot_no : "--"}</div>;
        // { is_active ? "Active" : "Inactive" }
      },
    },
    {
      title: "Gender",
      dataIndex: "gender",
      key: "gender",
      render: (_, { gender }) => {
        return <div>{gender ? gender : "--"}</div>;
        // { is_active ? "Active" : "Inactive" }
      },
    },
    {
      title: "Flat Number",
      dataIndex: "flat_number",
      key: "flat_number",
      render: (_, { flat_number }) => {
        return <div>{flat_number ? flat_number : "--"}</div>;
        // { is_active ? "Active" : "Inactive" }
      },
    },
    {
      title: "Floor",
      dataIndex: "floor",
      key: "floor",
      render: (_, { floor }) => {
        return <div>{floor ? floor : "--"}</div>;
        // { is_active ? "Active" : "Inactive" }
      },
    },
    {
      title: "Parking",
      dataIndex: "parking_number",
      key: "parking_number",
      render: (_, { parking_number }) => {
        return <div>{parking_number ? parking_number : "--"}</div>;
        // { is_active ? "Active" : "Inactive" }
      },
    },
    {
      title: "Common Area",
      dataIndex: "common_area",
      key: "common_area",
      render: (_, { common_area }) => {
        return <div>{common_area ? common_area : "--"}</div>;
        // { is_active ? "Active" : "Inactive" }
      },
    },

    {
      title: "Actual Area",
      dataIndex: "actual_area",
      key: "actual_area",
      render: (_, { actual_area }) => {
        return <div>{actual_area ? actual_area : "--"}</div>;
        // { is_active ? "Active" : "Inactive" }
      },
    },
    {
      title: "Municipality Number",
      dataIndex: "municioality_number",
      key: "municioality_number",
      render: (_, { municioality_number }) => {
        return <div>{municioality_number ? municioality_number : "--"}</div>;
        // { is_active ? "Active" : "Inactive" }
      },
    },
    {
      title: "Secondary Mobile",
      dataIndex: "secondary_mobile",
      key: "secondary_mobile",
      render: (_, { secondary_mobile }) => {
        return <div>{secondary_mobile ? secondary_mobile : "--"}</div>;
        // { is_active ? "Active" : "Inactive" }
      },
    },
  ];
  const columns = [
    visibleFields.file_name && {
      title: "File Name",
      dataIndex: "file_name",
      key: "file_name",
      render: (_, { downtownData }) => {
        return (
          <div>
            {downtownData
              ? downtownData.file_name
                ? downtownData.file_name
                : "-"
              : "-"}
          </div>
        );
      },
    },
    visibleFields.location && {
      title: "Location",
      render: (_, { downtownData }) => {
        return (
          <div>
            {downtownData
              ? downtownData.locationData
                ? downtownData.locationData.name
                : "-"
              : "-"}
          </div>
        );
      },
    },
    visibleFields.project_name && {
      title: "Project",
      render: (_, { downtownData }) => {
        return (
          <div>
            {downtownData
              ? downtownData.projectData
                ? downtownData.projectData.name
                : "-"
              : "-"}
          </div>
        );
      },
    },

    visibleFields.gender && {
      title: "Gender",
      dataIndex: "gender",
      key: "gender",
      render: (_, { gender }) => {
        return <div>{gender ? gender : "--"}</div>;
        // { is_active ? "Active" : "Inactive" }
      },
    },


    visibleFields.land_number_plot_no && {
      title: "Land Number",
      dataIndex: "land_number_plot_no",
      key: "land_number_plot_no",
      render: (_, { land_number_plot_no }) => {
        return <div>{land_number_plot_no ? land_number_plot_no : "--"}</div>;
        // { is_active ? "Active" : "Inactive" }
      },
    },


    visibleFields.company_name && {
      title: "Company Name",
      dataIndex: "company_name",
      key: "company_name",
      render: (_, { company_name }) => {
        return <div>{company_name ? company_name : "--"}</div>;
        // { is_active ? "Active" : "Inactive" }
      },
    },


    visibleFields.name && {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (_, { name }) => {
        return <div>{name ? name : "--"}</div>;
        // { is_active ? "Active" : "Inactive" }
      },
    },
    visibleFields.email && {
      title: "Email",
      dataIndex: "email",
      key: "email",
      render: (_, { email }) => {
        return <div>{email ? email : "--"}</div>;
        // { is_active ? "Active" : "Inactive" }
      },
    },
    visibleFields.phone && {
      title: "Phone",
      dataIndex: "phone",
      key: "phone",
      render: (_, { phone }) => {
        return <div>{phone ? phone : "--"}</div>;
        // { is_active ? "Active" : "Inactive" }
      },
    },
    visibleFields.country_code && {
      title: "Country Code",
      dataIndex: "country_code",
      key: "country_code",
      render: (_, { country_code }) => {
        return <div>{country_code ? country_code : "--"}</div>;
        // { is_active ? "Active" : "Inactive" }
      },
    },
    visibleFields.mobile_number && {
      title: "Mobile Number",
      dataIndex: "mobile_number",
      key: "mobile_number",
      render: (_, { mobile_number }) => {
        return <div>{mobile_number ? mobile_number : "--"}</div>;
        // { is_active ? "Active" : "Inactive" }
      },
    },
    visibleFields.mobile_number_code && {
      title: "Full Mobile Number",
      dataIndex: "mobile_number_code",
      key: "mobile_number_code",
      render: (_, { country_code, mobile_number }) => {
        return (
          <div>
            {country_code && mobile_number
              ? country_code +
              (mobile_number.startsWith("0")
                ? mobile_number.slice(1)
                : mobile_number)
              : mobile_number && mobile_number.startsWith("0")
                ? mobile_number.slice(1)
                : mobile_number}
          </div>
        );
        // { is_active ? "Active" : "Inactive" }
      },
    },
    visibleFields.flat_number && {
      title: "Flat Number",
      dataIndex: "flat_number",
      key: "flat_number",
      render: (_, { flat_number }) => {
        return <div>{flat_number ? flat_number : "--"}</div>;
        // { is_active ? "Active" : "Inactive" }
      },
    },
    visibleFields.vila_number && {
      title: "Vila Number",
      dataIndex: "vila_number",
      key: "vila_number",
      render: (_, { vila_number }) => {
        return <div>{vila_number ? vila_number : "--"}</div>;
        // { is_active ? "Active" : "Inactive" }
      },
    },
    visibleFields.plot_number && {
      title: "Plot Number",
      dataIndex: "plot_number",
      key: "plot_number",
      render: (_, { plot_number }) => {
        return <div>{plot_number ? plot_number : "--"}</div>;
        // { is_active ? "Active" : "Inactive" }
      },
    },
    visibleFields.building_name && {
      title: "Building Name",
      dataIndex: "building_name",
      key: "building_name",
      render: (_, { building_name }) => {
        return <div>{building_name ? building_name : "--"}</div>;
        // { is_active ? "Active" : "Inactive" }
      },
    },
    visibleFields.room_description && {
      title: "Rooms",
      dataIndex: "room",
      key: "room",
      render: (_, { room_description }) => {
        return <div>{room_description ? room_description : "--"}</div>;
        // { is_active ? "Active" : "Inactive" }
      },
    },
    visibleFields.type && {
      title: "Property Type",
      dataIndex: "type",
      key: "type",
      render: (_, { downtownData }) => {
        return <div>{downtownData ? downtownData.type : "--"}</div>;
        // { is_active ? "Active" : "Inactive" }
      },
    },
    visibleFields.floor && {
      title: "Floor",
      dataIndex: "floor",
      key: "floor",
      render: (_, { floor }) => {
        return <div>{floor ? floor : "--"}</div>;
        // { is_active ? "Active" : "Inactive" }
      },
    },
    visibleFields.parking_number && {
      title: "Parking",
      dataIndex: "parking_number",
      key: "parking_number",
      render: (_, { parking_number }) => {
        return <div>{parking_number ? parking_number : "--"}</div>;
        // { is_active ? "Active" : "Inactive" }
      },
    },
    visibleFields.common_area && {
      title: "Common Area",
      dataIndex: "common_area",
      key: "common_area",
      render: (_, { common_area }) => {
        return <div>{common_area ? common_area : "--"}</div>;
        // { is_active ? "Active" : "Inactive" }
      },
    },
    visibleFields.actual_area && {
      title: "Actual Area",
      dataIndex: "actual_area",
      key: "actual_area",
      render: (_, { actual_area }) => {
        return <div>{actual_area ? actual_area : "--"}</div>;
        // { is_active ? "Active" : "Inactive" }
      },
    },
    visibleFields.municioality_number && {
      title: "Municipality Number",
      dataIndex: "municioality_number",
      key: "municioality_number",
      render: (_, { municioality_number }) => {
        return <div>{municioality_number ? municioality_number : "--"}</div>;
        // { is_active ? "Active" : "Inactive" }
      },
    },
    visibleFields.secondary_mobile && {
      title: "Secondary Mobile",
      dataIndex: "secondary_mobile",
      key: "secondary_mobile",
      render: (_, { secondary_mobile }) => {
        return <div>{secondary_mobile ? secondary_mobile : "--"}</div>;
        // { is_active ? "Active" : "Inactive" }
      },
    },
    visibleFields.country && {
      title: "Country",
      dataIndex: "country",
      key: "country",
      render: (_, { country }) => {
        return <div>{country ? country : "--"}</div>;
        // { is_active ? "Active" : "Inactive" }
      },
    },
    visibleFields.nationality && {
      title: "Nationality",
      dataIndex: "nationality",
      key: "nationality",
      render: (_, { nationality }) => {
        return <div>{nationality ? nationality : "--"}</div>;
        // { is_active ? "Active" : "Inactive" }
      },
    },
    visibleFields.property_number && {
      title: "P-Number",
      dataIndex: "property_number",
      key: "property_number",
      render: (_, { property_number }) => {
        return <div>{property_number ? property_number : "--"}</div>;
        // { is_active ? "Active" : "Inactive" }
      },
    },
    !deselectAllChecked &&
    activeTab === "refine" && {
      title: "Action",
      render: (_, record) => (
        <div className="cta_wrap">
          <Button
            className="tb-view"
            onClick={() => ViewDataChange(record._id, activeTab)}
          >
            <i className="fa fa-light fa-eye"></i>
          </Button>
          <Button className="tb-view">
            <a
              href={`https://wa.me/${record.country_code
                ? record.country_code + record.mobile_number
                : record.mobile_number
                }`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-whatsapp"></i>
            </a>
          </Button>
          <Button className="tb-view">
            <a href={`mailto:${record.email ? record.email : ""}`}>
              <i className="far fa-envelope"></i>
            </a>
          </Button>
          <Button className="tb-view">
            <a href={`tel:${record.mobile_number}`}>
              <i className="fas fa-phone"></i>
            </a>
          </Button>
          <Button className="tb-view" onClick={() => handleEdit(record)}>
            <i className="fas fa-edit"></i>
          </Button>
          <Button
            onClick={() => navigate(`/activity-list/${record._id}`)}
            type="primary"
            className="ml-2"
          >
            <i class="fas fa-stream"></i>
          </Button>
        </div>
      ),
    },
  ].filter(Boolean);
  const resetSearchPagination = () => {
    setPagination((prev) => ({ ...prev, current: 1 }));
  };

  const handleInternalSearchChange = (e) => {
    setSearchText(e.target.value);
    resetSearchPagination();
  };

  const handleInternalSearchSubmit = (value) => {
    setSearchText(value ?? "");
    resetSearchPagination();
  };
  useEffect(() => {
    if (!params?.id) {
      setIsRestoreReady(true);
      return;
    }

    // Auto-restore for this selected file set when reopening the page.
    setIsRestoreReady(false);
    request({
      url: `/admin/downtown/undo-data/${params.id}`,
      method: "get",
      onSuccess: () => {
        setIsRestoreReady(true);
      },
      onError: () => {
        setIsRestoreReady(true);
      },
    });
  }, [params?.id]);

  useEffect(() => {
    if (!isRestoreReady) return;
    setLoading(true);
    fetchData(pagination);
    fetchDataExport();
  }, [refresh, activeTab, debouncedSearchParams, debouncedSearchText, isRestoreReady]);

  const fetchData = (pagination, filters) => {
    // Backend uses only per-field flags (name=true&email=false…); booleans become "true"/"false" in the query string.
    const isCountryCodeLikeSearch = /^\+?\d{1,4}$/.test(
      String(debouncedSearchText || "").trim()
    );
    const effectiveSearchFields = { ...debouncedSearchParams };
    if (isCountryCodeLikeSearch && !effectiveSearchFields.country_code) {
      effectiveSearchFields.mobile_number = false;
      effectiveSearchFields.phone = false;
      effectiveSearchFields.mobile_number_code = false;
      effectiveSearchFields.secondary_mobile = false;
    }
    const query = new URLSearchParams({
      page: pagination.current,
      limit: pagination.pageSize ?? 10,
      ...effectiveSearchFields,
    }).toString();
    request({
      url: `/admin/downtown/list-view-new/${params.id}/${activeTab}?search=${encodeURIComponent(
        debouncedSearchText || ""
      )}&${query}`,
      method: "GET",
      onSuccess: (data) => {
        setLoading(false);
        console.log(data, "data");
        // ShowToast(data.message, Severty.SUCCESS)
        setList(data.data.docs);
        setPagination((prev) => ({
          current: pagination.current,
          total: data.data.totalDocs,
          pageSize: data.data.limit,
        }));
      },
      onError: (error) => {
        ShowToast(error, Severty.ERROR);
      },
    });
  };
  const handleChange = (pagination, filters) => {
    console.log(pagination, filters);
    setPagination((prev) => ({
      ...prev,
      current: pagination.current,
      pageSize: pagination.pageSize ?? prev.pageSize ?? 10,
    }));
    fetchData(pagination, filters);
  };
  useEffect(() => {
    if (tableRef.current) {
      tableRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [pagination.current]);
  const handleTabChange = (key) => {
    console.log("Active tab:", key);
    setActiveTab(key);
  };

  const showConfirm = (type) => {
    setTimeout(() => {
      confirm({
        icon: <ExclamationCircleOutlined />,
        content: (
          <Button>Are you sure you want delete duplicate data ? </Button>
        ),
        onOk() {
          statusChange(type);
        },
        onCancel() {
          console.log("Cancel");
        },
      });
    }, 5);
  };
  const statusChange = (type) => {
    setLoading(true);
    request({
      url: `/admin/downtown/remove-duplicate-data/${type}/${params.id}`,
      method: "get",
      onSuccess: (data) => {
        setLoading(false);
        setRefresh((prev) => !prev);
      },
      onError: (error) => {
        console.log(error);
        ShowToast(error, Severty.ERROR);
      },
    });
  };
  const UndoData = () => {
    setLoading(true);
    request({
      url: `/admin/downtown/undo-data/${params.id}`,
      method: "get",
      onSuccess: (data) => {
        setLoading(false);
        setRefresh((prev) => !prev);
      },
      onError: (error) => {
        console.log(error);
        ShowToast(error, Severty.ERROR);
      },
    });
  };
  const fetchDataExport = (pagination, filters) => {
    const isCountryCodeLikeSearch = /^\+?\d{1,4}$/.test(
      String(debouncedSearchText || "").trim()
    );
    const effectiveSearchFields = { ...debouncedSearchParams };
    if (isCountryCodeLikeSearch && !effectiveSearchFields.country_code) {
      effectiveSearchFields.mobile_number = false;
      effectiveSearchFields.phone = false;
      effectiveSearchFields.mobile_number_code = false;
      effectiveSearchFields.secondary_mobile = false;
    }
    const query = new URLSearchParams({
      page: 1,
      limit: 50000,
      ...effectiveSearchFields,
    }).toString();
    request({
      url: `/admin/downtown/list-view-new/${params.id}/${activeTab}?search=${encodeURIComponent(
        debouncedSearchText || ""
      )}&${query}`,
      method: "GET",
      onSuccess: (data) => {
        setLoading(false);
        console.log(data, "data");
        setListExport(data?.data?.docs || []);
      },
      onError: (error) => {
        ShowToast(error, Severty.ERROR);
      },
    });
  };
  const handleSave = (values) => {
    console.log(values, "values");
    setLoading(true);
    request({
      url: `/admin/downtown/edit-data/${editingRecord._id}`,
      method: "POST",
      data: values,
      onSuccess: (data) => {
        console.log(data, "data");
        setLoading(false);
        if (data.status) {
          setLoading(false);
          ShowToast(data.message, Severty.SUCCESS);
          setIsModalVisible(false);
          setRefresh((prev) => !prev);
          setActiveTab(activeTab);
        } else {
          setLoading(false);
          ShowToast(data.message, Severty.ERROR);
        }
      },
      onError: (error) => {
        console.log(error);
        ShowToast(error.response.data.errors[0].message, Severty.ERROR);
        setLoading(false);
      },
    });
  };
  const toggleFieldVisibility = (field) => {
    setVisibleFields((prevFields) => {
      const updatedFields = { ...prevFields, [field]: !prevFields[field] };
      if (!updatedFields[field]) {
        setSelectAllChecked(false);
      }
      if (updatedFields[field]) {
        setDeselectAllChecked(false);
      }
      return updatedFields;
    });
  };
  const toggleFieldVisibilityNew = (field) => {
    setVisibleFieldsNew((prevFields) => {
      const updatedFields = { ...prevFields, [field]: !prevFields[field] };
      if (!updatedFields[field]) {
        setSelectAllCheckedNew(false);
      }
      if (updatedFields[field]) {
        setDeselectAllCheckedNew(false);
      }
      return updatedFields;
    });
  };
  const handleSelectAll = () => {
    const allTrue = Object.keys(visibleFields).reduce((result, key) => {
      result[key] = true;
      return result;
    }, {});
    setVisibleFields(allTrue);
    setSelectAllChecked(true);
    setDeselectAllChecked(false);
  };
  const handleDeselectAll = () => {
    const allFalse = Object.keys(visibleFields).reduce((result, key) => {
      result[key] = false;
      return result;
    }, {});
    setVisibleFields(allFalse);
    setSelectAllChecked(false);
    setDeselectAllChecked(true);
  };
  useEffect(() => {
    const allSelected = Object.values(visibleFields).every((value) => value);
    setSelectAllChecked(allSelected);
    const noneSelected = Object.values(visibleFields).every((value) => !value);
    setDeselectAllChecked(noneSelected);
  }, [visibleFields]);
  const handleSelectAllNew = () => {
    const allTrue = Object.keys(visibleFieldsNew).reduce((result, key) => {
      result[key] = true;
      return result;
    }, {});
    setVisibleFieldsNew(allTrue);
    setSelectAllCheckedNew(true);
    setDeselectAllCheckedNew(false);
  };
  const handleDeselectAllNew = () => {
    const allFalse = Object.keys(visibleFieldsNew).reduce((result, key) => {
      result[key] = false;
      return result;
    }, {});
    setVisibleFieldsNew(allFalse);
    setSelectAllCheckedNew(false);
    setDeselectAllCheckedNew(true);
  };
  useEffect(() => {
    const allSelected = Object.values(visibleFieldsNew).every((value) => value);
    setSelectAllCheckedNew(allSelected);
    const noneSelected = Object.values(visibleFieldsNew).every(
      (value) => !value
    );
    setDeselectAllCheckedNew(noneSelected);
  }, [visibleFieldsNew]);
  return (
    <Main>
      <Tabs
        activeKey={activeTab}
        onChange={handleTabChange}
        className="main-new-tans-class-kjh8u"
      >
        <TabPane tab="Raw Data" key="raw">
          <Row>
            <Col xs="24" md={24} lg={24} xl={24}>
              <Card
                bordered={false}
                className="criclebox tablespace mb-24"
                title="Raw Data"
                extra={
                  <>
                    <Search
                      allowClear
                      value={searchText}
                      onChange={handleInternalSearchChange}
                      onSearch={handleInternalSearchSubmit}
                      placeholder="Global Search"
                    />

                    <Button>Total Record :{pagination.total}</Button>
                  </>
                }
              >
                <div className="table-responsive">
                  <Table
                    loading={loading}
                    columns={RowDatacolumns}
                    dataSource={list}
                    pagination={pagination}
                    onChange={handleChange}
                    className="ant-border-space"
                  />
                </div>
              </Card>
            </Col>
          </Row>
        </TabPane>
        <TabPane tab="Refine Data" key="refine">
          <Row>
            <Col xs="24" md={24} lg={24} xl={24}>
              <Card
                bordered={false}
                className="criclebox tablespace mb-24 new-flex-class-mainjh"
                title="Refine Data"
                extra={
                  <>
                    <div className="search-and-rescord-buttonhj">
                      <Search
                        allowClear
                        value={searchText}
                        onChange={handleInternalSearchChange}
                        onSearch={handleInternalSearchSubmit}
                        placeholder="Internal Search"
                      />

                      <Button>Total Record :{pagination.total}</Button>
                    </div>

                    <div className="main-all-buttonclassokjh">
                      <Button
                        onClick={() => navigate(`/activity-list/${params.id}`)}
                        type="primary"
                        className="ml-2"
                      >
                        Activity
                      </Button>
                      <Button onClick={() => UndoData()} className="ml-2">
                        Undo Data
                      </Button>
                      <Button
                        onClick={() => showConfirm("email")}
                        className="ml-2"
                      >
                        Remove Duplicate Emails
                      </Button>
                      <Button
                        onClick={() => showConfirm("mobile")}
                        className="ml-2"
                      >
                        Remove Duplicate Phones
                      </Button>
                      <Button
                        type="primary"
                        icon={<ExportOutlined />}
                        onClick={handleExport}
                      >
                        Export
                      </Button>
                    </div>
                  </>
                }
              >
                <div className="all-check-box-desing-main09">
                  <Collapse accordion>
                    <Panel header="For Show/Hide" key="1">
                      <div className="all-check-box-desing">
                        <Checkbox
                          checked={visibleFields.file_name}
                          onClick={() => toggleFieldVisibility("file_name")}
                        >
                          File Name
                        </Checkbox>
                        <Checkbox
                          checked={visibleFields.project_name}
                          onClick={() => toggleFieldVisibility("project_name")}
                        >
                          Project
                        </Checkbox>
                        <Checkbox
                          checked={visibleFields.location}
                          onClick={() => toggleFieldVisibility("location")}
                        >
                          Location
                        </Checkbox>

                        <Checkbox
                          checked={visibleFields.name}
                          onClick={() => toggleFieldVisibility("name")}
                        >
                          Name
                        </Checkbox>
                        <Checkbox
                          checked={visibleFields.email}
                          onClick={() => toggleFieldVisibility("email")}
                        >
                          Email
                        </Checkbox>
                        <Checkbox
                          checked={visibleFields.phone}
                          onClick={() => toggleFieldVisibility("phone")}
                        >
                          Phone
                        </Checkbox>
                        <Checkbox
                          checked={visibleFields.country_code}
                          onClick={() => toggleFieldVisibility("country_code")}
                        >
                          Country Code
                        </Checkbox>
                        <Checkbox
                          checked={visibleFields.mobile_number}
                          onClick={() => toggleFieldVisibility("mobile_number")}
                        >
                          Mobile Number
                        </Checkbox>
                        <Checkbox
                          checked={visibleFields.mobile_number_code}
                          onClick={() =>
                            toggleFieldVisibility("mobile_number_code")
                          }
                        >
                          Mobile Number With Code
                        </Checkbox>

                        <Checkbox
                          checked={visibleFields.flat_number}
                          onClick={() => toggleFieldVisibility("flat_number")}
                        >
                          Flat Number
                        </Checkbox>
                        <Checkbox
                          checked={visibleFields.plot_number}
                          onClick={() => toggleFieldVisibility("plot_number")}
                        >
                          Plot Number
                        </Checkbox>
                        <Checkbox
                          checked={visibleFields.vila_number}
                          onClick={() => toggleFieldVisibility("vila_number")}
                        >
                          Vila Number
                        </Checkbox>
                        <Checkbox
                          checked={visibleFields.room_description}
                          onClick={() =>
                            toggleFieldVisibility("room_description")
                          }
                        >
                          Rooms
                        </Checkbox>
                        <Checkbox
                          checked={visibleFields.type}
                          onClick={() => toggleFieldVisibility("type")}
                        >
                          Type
                        </Checkbox>
                        <Checkbox
                          checked={visibleFields.floor}
                          onClick={() => toggleFieldVisibility("floor")}
                        >
                          Floor
                        </Checkbox>
                        <Checkbox
                          checked={visibleFields.building_name}
                          onClick={() => toggleFieldVisibility("building_name")}
                        >
                          Building Name
                        </Checkbox>

                        <Checkbox
                          checked={visibleFields.actual_area}
                          onClick={() => toggleFieldVisibility("actual_area")}
                        >
                          Actual Area
                        </Checkbox>
                        <Checkbox
                          checked={visibleFields.common_area}
                          onClick={() => toggleFieldVisibility("common_area")}
                        >
                          Common Area
                        </Checkbox>
                        <Checkbox
                          checked={visibleFields.parking_number}
                          onClick={() =>
                            toggleFieldVisibility("parking_number")
                          }
                        >
                          Parking
                        </Checkbox>
                        <Checkbox
                          checked={visibleFields.country}
                          onClick={() => toggleFieldVisibility("country")}
                        >
                          Country
                        </Checkbox>

                        <Checkbox
                          checked={visibleFields.nationality}
                          onClick={() => toggleFieldVisibility("nationality")}
                        >
                          Nationality
                        </Checkbox>
                        <Checkbox
                          checked={visibleFields.municioality_number}
                          onClick={() =>
                            toggleFieldVisibility("municioality_number")
                          }
                        >
                          Municipality
                        </Checkbox>
                        <Checkbox
                          checked={visibleFields.secondary_mobile}
                          onClick={() =>
                            toggleFieldVisibility("secondary_mobile")
                          }
                        >
                          Secondary Mobile
                        </Checkbox>

                        <Checkbox
                          checked={visibleFields.property_number}
                          onClick={() =>
                            toggleFieldVisibility("property_number")
                          }
                        >
                          P-Number
                        </Checkbox>
                        <Checkbox
                          checked={visibleFields.note}
                          onClick={() => toggleFieldVisibility("note")}
                        >
                          Comment
                        </Checkbox>

                        <Checkbox
                          checked={selectAllChecked}
                          onClick={handleSelectAll}
                        >
                          Select All
                        </Checkbox>
                        <Checkbox
                          checked={deselectAllChecked}
                          onClick={handleDeselectAll}
                        >
                          Deselect All
                        </Checkbox>
                      </div>
                    </Panel>
                  </Collapse>
                </div>
                <div className="all-check-box-desing-main09">
                  <Collapse accordion>
                    <Panel header="For Search" key="1">
                      <div className="all-check-box-desing">
                        <Checkbox
                          checked={visibleFieldsNew.file_name}
                          onClick={() => toggleFieldVisibilityNew("file_name")}
                        >
                          File Name
                        </Checkbox>
                        <Checkbox
                          checked={visibleFieldsNew.project_name}
                          onClick={() =>
                            toggleFieldVisibilityNew("project_name")
                          }
                        >
                          Project
                        </Checkbox>
                        <Checkbox
                          checked={visibleFieldsNew.location}
                          onClick={() => toggleFieldVisibilityNew("location")}
                        >
                          Location
                        </Checkbox>
                        <Checkbox
                          checked={visibleFieldsNew.name}
                          onClick={() => toggleFieldVisibilityNew("name")}
                        >
                          Name
                        </Checkbox>
                        <Checkbox
                          checked={visibleFieldsNew.email}
                          onClick={() => toggleFieldVisibilityNew("email")}
                        >
                          Email
                        </Checkbox>
                        <Checkbox
                          checked={visibleFieldsNew.phone}
                          onClick={() => toggleFieldVisibilityNew("phone")}
                        >
                          Phone
                        </Checkbox>
                        <Checkbox
                          checked={visibleFieldsNew.country_code}
                          onClick={() =>
                            toggleFieldVisibilityNew("country_code")
                          }
                        >
                          Country Code
                        </Checkbox>
                        <Checkbox
                          checked={visibleFieldsNew.mobile_number}
                          onClick={() =>
                            toggleFieldVisibilityNew("mobile_number")
                          }
                        >
                          Mobile Number
                        </Checkbox>
                        <Checkbox
                          checked={visibleFieldsNew.mobile_number_code}
                          onClick={() =>
                            toggleFieldVisibilityNew("mobile_number_code")
                          }
                        >
                          Mobile Number With Code
                        </Checkbox>
                        <Checkbox
                          checked={visibleFieldsNew.flat_number}
                          onClick={() =>
                            toggleFieldVisibilityNew("flat_number")
                          }
                        >
                          Flat Number
                        </Checkbox>
                        <Checkbox
                          checked={visibleFieldsNew.plot_number}
                          onClick={() =>
                            toggleFieldVisibilityNew("plot_number")
                          }
                        >
                          Plot Number
                        </Checkbox>
                        <Checkbox
                          checked={visibleFieldsNew.vila_number}
                          onClick={() =>
                            toggleFieldVisibilityNew("vila_number")
                          }
                        >
                          Vila Number
                        </Checkbox>
                        <Checkbox
                          checked={visibleFieldsNew.room_description}
                          onClick={() =>
                            toggleFieldVisibilityNew("room_description")
                          }
                        >
                          Rooms
                        </Checkbox>
                        <Checkbox
                          checked={visibleFieldsNew.type}
                          onClick={() => toggleFieldVisibilityNew("type")}
                        >
                          Type
                        </Checkbox>
                        <Checkbox
                          checked={visibleFieldsNew.floor}
                          onClick={() => toggleFieldVisibilityNew("floor")}
                        >
                          Floor
                        </Checkbox>
                        <Checkbox
                          checked={visibleFieldsNew.building_name}
                          onClick={() =>
                            toggleFieldVisibilityNew("building_name")
                          }
                        >
                          Building Name
                        </Checkbox>
                        <Checkbox
                          checked={visibleFieldsNew.actual_area}
                          onClick={() =>
                            toggleFieldVisibilityNew("actual_area")
                          }
                        >
                          Actual Area
                        </Checkbox>
                        <Checkbox
                          checked={visibleFieldsNew.common_area}
                          onClick={() =>
                            toggleFieldVisibilityNew("common_area")
                          }
                        >
                          Common Area
                        </Checkbox>
                        <Checkbox
                          checked={visibleFieldsNew.parking_number}
                          onClick={() =>
                            toggleFieldVisibilityNew("parking_number")
                          }
                        >
                          Parking
                        </Checkbox>
                        <Checkbox
                          checked={visibleFieldsNew.country}
                          onClick={() => toggleFieldVisibilityNew("country")}
                        >
                          Country
                        </Checkbox>
                        <Checkbox
                          checked={visibleFieldsNew.nationality}
                          onClick={() =>
                            toggleFieldVisibilityNew("nationality")
                          }
                        >
                          Nationality
                        </Checkbox>
                        <Checkbox
                          checked={visibleFieldsNew.municioality_number}
                          onClick={() =>
                            toggleFieldVisibilityNew("municioality_number")
                          }
                        >
                          Municipality
                        </Checkbox>
                        <Checkbox
                          checked={visibleFieldsNew.secondary_mobile}
                          onClick={() =>
                            toggleFieldVisibilityNew("secondary_mobile")
                          }
                        >
                          Secondary Mobile
                        </Checkbox>
                        <Checkbox
                          checked={visibleFieldsNew.property_number}
                          onClick={() =>
                            toggleFieldVisibilityNew("property_number")
                          }
                        >
                          P-Number
                        </Checkbox>
                        <Checkbox
                          checked={visibleFieldsNew.note}
                          onClick={() => toggleFieldVisibilityNew("note")}
                        >
                          Comment
                        </Checkbox>
                        <Checkbox
                          checked={selectAllCheckedNew}
                          onClick={handleSelectAllNew}
                        >
                          Select All
                        </Checkbox>
                        <Checkbox
                          checked={deselectAllCheckedNew}
                          onClick={handleDeselectAllNew}
                        >
                          Deselect All
                        </Checkbox>
                      </div>
                    </Panel>
                  </Collapse>
                </div>
                <div className="table-responsive">
                  <Table
                    loading={loading}
                    columns={columns}
                    dataSource={list}
                    pagination={pagination}
                    onChange={handleChange}
                    className="ant-border-space"
                  />
                </div>
              </Card>
            </Col>
          </Row>
        </TabPane>
      </Tabs>
      <EditRecordModal
        visible={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        onSave={handleSave}
        record={editingRecord}
        visibleFields={visibleFields}
      />
    </Main>
  );
};

export default DownTownData;
